import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import PackageLanding from "@/pages/PackageLanding";
import CantonFairLanding from "@/pages/CantonFairLanding";
import LuxuryHoneymoon from "@/pages/LuxuryHoneymoon";
import LuxuryHoneymoonDestination from "@/pages/LuxuryHoneymoonDestination";
import HoneymoonJournal from "@/pages/HoneymoonJournal";
import Packages from "@/pages/Packages";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Destination from "@/pages/Destination";
import Blog from "@/pages/Blog";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import WhatsAppClickTracker from "@/components/WhatsAppClickTracker";
import { AuthProvider } from "@/lib/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function StaticRedirect({ to }) {
  window.location.replace(to + window.location.search);
  return null;
}

const CRM_URL = "https://vacationspro-crm-968186996157.asia-southeast1.run.app";
function CrmRedirect() {
  const rest = window.location.pathname.replace(/^\/crm\/?/, "");
  window.location.replace(`${CRM_URL}/${rest}${window.location.search}${window.location.hash}`);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <WhatsAppClickTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/lp" element={<Landing />} />
              <Route path="/canton-fair" element={<CantonFairLanding />} />
              <Route path="/lp/canton-fair" element={<CantonFairLanding />} />
              <Route path="/honeymoon-experiences" element={<LuxuryHoneymoon />} />
              <Route path="/honeymoon-experiences/:slug" element={<LuxuryHoneymoonDestination />} />
              <Route path="/honeymoon-journal" element={<HoneymoonJournal />} />
              <Route path="/honeymoon" element={<StaticRedirect to="/honeymoon/index.html" />} />
              <Route path="/family" element={<StaticRedirect to="/family/index.html" />} />
              <Route path="/crm/*" element={<CrmRedirect />} />
              <Route path="/lp/:slug" element={<PackageLanding />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/ads" element={<Landing />} />
              <Route path="/go" element={<Landing />} />
              <Route path="/about" element={<About />} />
              <Route path="/destinations/:slug" element={<Destination />} />
              <Route path="/blog/:id" element={<Blog />} />
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
